import { useEffect, useRef, useState } from "react";
import AnimationContainer from "../../../Reusable/AnimationContainer/AnimationContainer.js";
import { useContent } from "contexts/contentContext/contentContext.js";

const BOTTOM_PADDING = 10;
const TIMEOUT = 500;

const CustomPopup = ({ showState, children, topPosition = 10 }) => {
  const [style, setStyle] = useState({ top: topPosition + "px" });
  const ref = useRef();
  const { getDirection } = useContent();

  useEffect(() => {
    // move menu upper if it was rendered beyond the bottom window edge
    if (showState) {
      setTimeout(() => {
        const bottom = ref.current?.getBoundingClientRect().bottom;
        if (bottom > window.innerHeight) {
          const diff = bottom - window.innerHeight + BOTTOM_PADDING;
          setStyle({ top: topPosition - diff + "px" });
        }
      }, TIMEOUT);
    }
  }, [showState, topPosition]);

  useEffect(() => {
    if (ref.current && document.querySelector(".jm-form-container")) {
      const popupRects = ref.current?.getBoundingClientRect();
      if (!popupRects) return;
      const popupPosition = popupRects.height + popupRects.top + 20;
      const parentRects = document
        .querySelector(".jm-form-container")
        .getBoundingClientRect();
      const parentLimit = parentRects.height + parentRects.top;
      if (parentLimit < popupPosition) {
        setStyle({ bottom: topPosition + "px" });
      }
    }
  }, [showState]);

  // logic to detect when popup is cutted by screen
  useEffect(() => {
    if (ref.current) {
      // timeout exist cos need some time to get pictures if they theer are
      setTimeout(() => {
        const rect = ref.current?.getBoundingClientRect();
        // if ltr - need to check if left is less than 0 and move component to the right to this value
        if (getDirection() === "ltr") {
          if (rect?.left <= 0)
            setStyle((prev) => ({
              ...prev,
              transform: `translateX(${Math.round(-rect?.left) + 10}px)`,
            }));
        } else {
          // if rtl - check if right position is bigger than window width and move component to the left to this value
          const difference = rect?.right - window.innerWidth;
          if (difference >= 0)
            setStyle((prev) => ({
              ...prev,
              transform: `translateX(${Math.round(-difference) - 10}px)`,
            }));
        }
      }, 300);
    }
  }, [ref.current, showState]);

  return (
    <AnimationContainer animationOn={showState} animationClassName="fade-in">
      <div className="absolute-pos-container" style={style} ref={ref}>
        {children}
      </div>
    </AnimationContainer>
  );
};

export default CustomPopup;
